import { SecondStageVotesT } from '../../../model/types';

interface IAddNewVoteArgs {
  newSecondStageUnit: SecondStageVotesT | null,
  secondStageUnit: SecondStageVotesT | null
}
export const addNewSecondStageUnits = ({
  secondStageUnit,
  newSecondStageUnit
}: IAddNewVoteArgs): SecondStageVotesT | null => {
  if (!newSecondStageUnit) {
    return null;
  }

  if (!secondStageUnit) {
    return newSecondStageUnit;
  }

  return ({ ...secondStageUnit, ...newSecondStageUnit });
};
